import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#2ea3ff'
const purple = '#655eff'
const pink = '#e542ff'

export const otherworldphila: TenantConfig = {
  logo: 'assets/otherworldphila/static/white.png',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: purple,
    secondaryColor: pink,
    logoHeight: '25px',
    headerHeight: '80px',
    headerBackground: 'black',
    cartHeaderBackgroundColor: blue,
    dialog: {
      headerBackground: blue,
      headerTextColor: 'white',
      headerIconColor: 'white',
    },
    memberLinksColor: 'white',
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
  },
  componentOptions: {
    completedOrdersRoute: {
      completedContentOffset: {
        desktop: '-240px',
        mobile: '-130px',
      },
    },
  },
}
